<script>
  import { getContext, onMount } from 'svelte'
  import { formatThousands, formatDateLong, formatDateShort } from './functions'
  let { nData, cData, margin } = getContext('chart')
  let nationalData = nData()
  let incomingData = cData()

  incomingData.forEach((d) => {
    d.casesSevenDays = +d['7_day_weekly_average']
    d.vaccinationsSevenDays = +d['vaccinations_7_day_average']
    d.casesDaily = +d['cases_daily']
  })

  console.log(incomingData)
</script>

<div class="chart-title">Current Status</div>
<div class="updated">
  Updated: {formatDateLong(incomingData[incomingData.length - 1].date)}
</div>
<div class="table">
  <div class="table-row">
    <div class="td label">Total Confirmed Cases:</div>
    <div class="td value">
      {formatThousands(incomingData[incomingData.length - 1].cumulative_cases)}
    </div>
    <div class="td change" />
    <div class="td change" />
  </div>
  <div class="table-row">
    <div class="td label">Total Confirmed Deaths:</div>
    <div class="td value">
      {formatThousands(incomingData[incomingData.length - 1].cumulative_deaths)}
    </div>
    <div class="td change" />
    <div class="td change" />
  </div>
  <div class="table-row">
    <div class="td label">
      New Cases:<br />
      <span class="small">7-Day Average:</span><br />
      <span class="small">Cases Yesterday:</span>
    </div>
    <div class="td value">
      {formatThousands(incomingData[incomingData.length - 1].casesDaily)}<br />

      <span class="small"
        >{formatThousands(
          incomingData[incomingData.length - 1].casesSevenDays
        )}</span
      ><br />
      <span class="small"
        >{formatThousands(
          incomingData[incomingData.length - 2].casesDaily
        )}</span
      >
    </div>
    <div class="td change">
      {#if incomingData[incomingData.length - 1].casesDaily > incomingData[incomingData.length - 1].casesSevenDays}
        <img src="/assets/arrow-up.svg" alt="Arrow Up" />
      {:else}
        <img src="/assets/arrow-down.svg" alt="Arrow Down" />
      {/if}
    </div>
    <!-- <div class="td change">
      {#if incomingData[incomingData.length - 1].casesDaily > incomingData[incomingData.length - 2].casesSevenDays}
        <img src="/assets/arrow-up.svg" alt="Arrow Up" />
      {:else}
        <img src="/assets/arrow-down.svg" alt="Arrow Down" />
      {/if}
    </div> -->
  </div>
  <div class="table-row">
    <div class="td label">
      New Deaths:<br />
      <span class="small">7-Day Average:</span><br />
      <span class="small">Deaths Yesterday:</span>
    </div>
    <div class="td value">
      {formatThousands(+incomingData[incomingData.length - 1].deaths_daily)}<br
      />

      <span class="small"
        >{(
          +incomingData[incomingData.length - 1].fatalities_seven_days / 7
        ).toFixed(0)}</span
      ><br />
      <span class="small"
        >{formatThousands(
          incomingData[incomingData.length - 2].deaths_daily
        )}</span
      >
    </div>
    <div class="td change">
      {#if incomingData[incomingData.length - 1].deaths_daily > +incomingData[incomingData.length - 1].fatalities_seven_days / 7}
        <img src="/assets/arrow-up.svg" alt="Arrow Up" />
      {:else}
        <img src="/assets/arrow-down.svg" alt="Arrow Down" />
      {/if}
    </div>
    <!-- <div class="td change">
      {#if incomingData[incomingData.length - 1].deaths_daily > +incomingData[incomingData.length - 2].fatalities_seven_days / 7}
        <img src="/assets/arrow-up.svg" alt="Arrow Up" />
      {:else}
        <img src="/assets/arrow-down.svg" alt="Arrow Down" />
      {/if}
    </div> -->
  </div>
  <!-- <div class="table-row">
    <div class="td label">New Deaths:</div>
    <div class="td value">
      {formatThousands(+incomingData[incomingData.length - 1].deaths_daily)}
    </div>
  </div> -->
</div>

<style>
  img {
    width: 20px;
    transform: translate(0px, 5px);
  }
  .updated {
    font-family: 'Roboto', Arial;
    text-transform: uppercase;
    font-size: 0.7rem;
  }
  .table {
    display: table;
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-size: 0.9rem;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.4rem;
  }
  .table-row {
    display: table-row;
  }
  .td {
    display: table-cell;
    border-bottom: solid 1px lightgray;
    /* border: solid 1px lightgray; */

    padding: 3px 5px;
    min-width: 50px;
  }
  .change {
    width: 30px;
    min-width: 0px;
  }

  .label {
    font-weight: 700;
    text-transform: uppercase;
    text-align: right;
  }
  .value {
    text-align: left;
  }
  .small {
    font-size: 0.7rem;
    font-weight: 400;
    color: gray;
  }
</style>
